import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { Flex } from 'pcln-design-system'
import TierBox from './TierBox'

const ShelfContainer = styled(Flex)``

export default class FareBrandShelfNGS extends React.Component {
  render() {
    const { upsells, onSelect, shelfVariantName } = this.props

    return (
      <ShelfContainer
        data-autobot-element='fare-brand-options'
        width={shelfVariantName === 'THREESHELVES' ? '55%' : '50%'}
      >
        <TierBox shelfVariantName={shelfVariantName} tier={1} handleClick={onSelect} upsell={upsells[0]} />
        <TierBox shelfVariantName={shelfVariantName} tier={2} handleClick={onSelect} upsell={upsells[1]} />
        <TierBox shelfVariantName={shelfVariantName} tier={3} handleClick={onSelect} upsell={upsells[2]} />
      </ShelfContainer>
    )
  }
}

FareBrandShelfNGS.defaultProps = {
  upsells: [],
}

FareBrandShelfNGS.propTypes = {
  itinerary: PropTypes.object,
  upsells: PropTypes.array,
  onSelect: PropTypes.func,
  gaIndex: PropTypes.number,
  shelfVariantName: PropTypes.string,
}

FareBrandShelfNGS.contextTypes = {
  flyGaLogic: PropTypes.object,
}
